// removed by extract-text-webpack-plugin
module.exports = {"contactInfo":"_3_zPT","email":"_2l_jE","subtext":"_1IZuV","forgotPasswordButton":"_185kV","error":"_1lb-y","input":"_1DYuV","invalid":"_22xFt","nameInput":"_1KaOh _1DYuV","emailInput":"_8b8Dr _1DYuV","phoneInput":"b7Hh1 _1DYuV","inputInvalid":"_2iaj0","passwordWrapper":"_3MOlx","passwordInput":"NyONZ _1DYuV","signInButton":"_3WbhW","poweredBy":"_2YtPa"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Checkout/ContactInfo/index.sass
// module id = 1466
// module chunks = 1